import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const initDynamicServicesAnimation = () => {
  const blocks = document.querySelectorAll(".wp-block-webvibe-block-dynamic-services");

  if (!blocks.length) return;

  blocks.forEach((block) => {
    const eyebrow = block.querySelector(".wv-portfolio-eyebrow");
    const heading = block.querySelector(".wv-portfolio-heading");
    const cards = block.querySelectorAll(".wv-service-card");

    if (eyebrow) {
      gsap.set(eyebrow, {
        autoAlpha: 0,
        y: 18,
      });
    }

    if (heading) {
      gsap.set(heading, {
        autoAlpha: 0,
        y: 24,
      });
    }

    gsap.set(cards, {
      autoAlpha: 0,
      y: 26,
    });

    const introTl = gsap.timeline({
      scrollTrigger: {
        trigger: block,
        start: "top 85%",
        once: true,
      },
      defaults: {
        ease: "power2.out",
      },
    });

    if (eyebrow) {
      introTl.to(eyebrow, {
        autoAlpha: 1,
        y: 0,
        duration: 0.45,
      });
    }

    if (heading) {
      introTl.to(
        heading,
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.5,
        },
        "-=0.2"
      );
    }

    cards.forEach((card, index) => {
      gsap.to(card, {
        autoAlpha: 1,
        y: 0,
        duration: 0.45,
        ease: "power2.out",
        delay: index % 3 * 0.12,
        scrollTrigger: {
          trigger: card,
          start: "top 70%",
          once: true,
        },
      });
    });
  });

  ScrollTrigger.refresh();
};

window.addEventListener("load", initDynamicServicesAnimation);